<ion-header [translucent]="true">
	<ion-toolbar class="payment-header">
		<ion-title class="ion-text-wrap">{{ 'cashPayment.title' | translate }}</ion-title>
		@if (cancelEnabled) {
			<ion-buttons slot="end">
				<ion-button (click)="paymentCancelled()" fill="clear">
					<ion-icon name="close"></ion-icon>
				</ion-button>
			</ion-buttons>
		}
	</ion-toolbar>
</ion-header>

<ion-content class="cash-payment">
	@if (order) {
		<div class="qr-container ion-text-center">
			<qrcode [errorCorrectionLevel]="'M'" [qrdata]="qrData" [width]="220" class="qr-code"></qrcode>

			<p [innerHTML]="cashDroHint" class="qr-instruction"></p>
			<p>
				<b>{{ 'cashPayment.warning' | translate }}</b> {{ 'cashPayment.codeValidFor' | translate }}
			</p>
			<h2>
				<b>{{ timeoutIn }}</b>
			</h2>
			<p>{{ 'cashPayment.validMessage' | translate }}</p>
		</div>
	} @else {
		<ion-spinner></ion-spinner>
	}
	@if (cancelEnabled) {
		<ion-button (click)="paymentCancelled()" class="button-outline"> {{ 'common.back' | translate }}</ion-button>
	}
</ion-content>

<ion-footer class="payment-footer">
	<!-- Tip Display (read-only) -->
	@if (paySessionStatistics?.tipsValue) {
		<app-info-row>
			<div left>{{ 'common.tipLabel' | translate }}</div>
			<div right>{{ formattedTips }}</div>
		</app-info-row>
	}
	<hr class="divider" />
	<app-info-row>
		<div left>
			{{ 'statistics.total' | translate }} (<span>{{ paySessionStatistics?.selectedProductsCount }}</span> &nbsp;{{
				'statistics.items' | translate
			}})
		</div>
		<div right>{{ formattedTotalPrice }}</div>
	</app-info-row>
</ion-footer>
